// @ts-nocheck
import React from "react";
import { useDispatch } from "react-redux";
import {
  setModalState,
  modalViewsConst,
  setModalOpen,
  closeModalWithResult
} from "../../store/modalSlice";
import { deleteAsset } from "../../store/assetsSlice";
import { deleteAssetGroupFunc } from "../../store/assetGroupSlice";
import { ReactComponent as GroupIcon } from "../../assets/icons/group-icon.svg";
import {
  delSolarEnModel,
  deletePCurve,
  deleteSolarEnergyModel,
} from "../../store/pCurveSlice";
import { deletePersonaFunc } from "../../store/personaSlice";
import { deleteComposedForecast } from "../../store/composedForecastSlice";
import { del } from 'aws-amplify/api';
import ModalBase from "./ModalBase";

interface DeleteApproveProps {
  data: {
    id: string;
    name: string;
    [key: string]: any;
  };
  deleteType: 'asset' | 'assetGroup' | 'pCurve' | 'SolarEnergyModel' | 'persona' | 'composedForecast';
  deleteTypeLabel: string;
  onClose?: (result?: any) => void;
}

const DeleteApprove: React.FC<DeleteApproveProps> = ({ 
  data, 
  deleteType, 
  deleteTypeLabel,
  onClose
}) => {
  const { name, id } = data;
  const dispatch = useDispatch();

  const handleDelete = async () => {
    try {
      let result;
      
      if (deleteType === "asset") {
        result = await dispatch(deleteAsset({ id }));
      } else if (deleteType === "assetGroup") {
        // await dispatch(deleteAssetGroupFunc({ id }));
        result = await handleCascadeDelete(id);
      } else if (deleteType === "pCurve") {
        result = await dispatch(deletePCurve({ id }));
      } else if (deleteType === "SolarEnergyModel") {
        result = await dispatch(delSolarEnModel({ id }));
      } else if (deleteType === "persona") {
        result = await dispatch(deletePersonaFunc({ id }));
      } else if (deleteType === "composedForecast") {
        // .unwrap() so a rejected thunk throws into the catch below — otherwise dispatch resolves with the rejected action and we'd report success.
        result = await dispatch(
          deleteComposedForecast({ id, dataSources: data.dataSources || [] })
        ).unwrap();
      }
      
      // Handle response with callback if available
      if (onClose) {
        onClose({
          success: true,
          id,
          type: deleteType,
          name,
          result
        });
      } else {
        // Backward compatibility
        dispatch(setModalOpen(false));
      }
    } catch (error) {
      console.error(`Error deleting ${deleteTypeLabel}:`, error);
      
      if (onClose) {
        onClose({
          success: false,
          error,
          id,
          type: deleteType
        });
      } else {
        dispatch(setModalOpen(false));
      }
    }
  };

  // #CodyFix styling
   const handleCascadeDelete = async (assetGroupId) => {
      try {
        const restOperation = del({
          apiName: 'crudopsapi',
          path: `/api/assetgroup/${assetGroupId}`
        });
        const res = await restOperation.response;
        console.log('DELETE call succeeded', res);
        console.log("Delete response:", res);
        window.location.reload()
      } catch (error) {
        console.error("Error deleting asset group:", error);
      }

    }

  const handleCloseModal = () => {
    if (onClose) {
      onClose();
    } else {
      dispatch(setModalOpen(false));
    }
  };

  return (
    <ModalBase
      title={`Delete ${deleteTypeLabel}`}
      icon={<GroupIcon className="h-6 w-6" />}
      onClose={handleCloseModal}
      size="sm"
      footer={
        <>
          <button className="eai-btn-outline" type="button" onClick={handleCloseModal}>
            Cancel
          </button>
          <button onClick={handleDelete} className="eai-btn-danger" type="button">
            Delete
          </button>
        </>
      }
    >
      <div className="flex flex-col gap-2">
        <p className="eai-panel-title">
          Are you sure you want to permanently delete your {deleteTypeLabel} named {name}?
        </p>
        <p className="font-inter text-eai-body-sm text-eai-danger-text">
          This action can not be undone!
        </p>
      </div>
    </ModalBase>
  );
};

export default DeleteApprove;
